module.exports = __webpack_public_path__ + "img/48.6f3b1e21.jpg";